import React from 'react';
import styled from 'styled-components';
import Navbar from './Navbar';
import DesktopMenu from './DesktopMenu';
import Footer from './Footer';
import coverImg from '../images/membership_cover.png';

const GUMROAD_URL = 'https://spectralcenter.gumroad.com/l/membership?layout=profile';

const Membership = () => {
    return (
        <>
            <Navbar/>
            <DeskWrap>
                <DesktopMenu/>
                <Wrapper>
                    <Body>
                        <h1>The Spectral Center Membership</h1>
                        <Price>€15 / month</Price>
                        <CoverImage src={coverImg} alt="Spectral Center Membership" />

                        <p>You already know something's off. Not dramatically — you're not in crisis. You're doing the work, taking the action, showing up for the life you say you want. And still, some part of you keeps circling back to the same old shape. Same fear. Same hesitation right before the thing that would actually change something.</p>

                        <p>That's not a discipline problem. It's a subconscious one. The mind that runs your habits, your fear responses, your sense of what's possible for you, doesn't take instructions from willpower. It takes them from the state you're actually in when the instruction is given. That's what hypnosis works with — not your intentions, your state.</p>

                        <p>I'm an artist and a hypnotherapist. My work sits at the place where trance, sound, and creative practice meet, and I've spent years building sessions and recordings that use hypnosis the way an artist would: not as a productivity hack, but as a way into the parts of you that are already trying to speak.</p>

                        <p>The membership is where that work lives — a daily practices for reconnecting with your own instinct and imagination as sources of information, not just inspiration.</p>

                        <h3>This is for you if</h3>
                        <p>You keep landing back in a loop you thought you'd already worked through. You're fluent in the language of growth and healing and still feel disconnected from your own instincts. You're building toward something — a body of work, a life, a version of yourself — and you want your subconscious working with you on it instead of quietly working against you.</p>

                        <h3>What's inside</h3>
                        <p>A library of over twenty self-hypnosis recordings — for confidence, abundance, deep sleep, anxiety, stress, addiction release, trauma repair, and cutting the cords that keep you tethered to old versions of your life.</p>
                        <p> <a href="/creative-signal-ritual">The Creative Signal 21-day ritual</a>, a daily practice for training attention back toward instinct.</p>
                        <p><a href="/strategy-of-futureness">The Strategy of Futureness</a>, a four-week workshop that uses hypnosis and speculative fiction to build a working relationship with a future self, not as fantasy but as material.</p>
                        <p><a href="/the-container">The Container</a>, a session for clarity, boundaries, and trusting your own read on things.</p>
                        <p>Seasonal workshops timed to the natural cycles of the year, and a monthly live group hypnosis session where you're in trance alongside other people doing this work.</p>
                        <p>New recordings added monthly, plus the ability to request one built around whatever you're actually moving through.</p>

                        <p>If this is the kind of work you're ready for, join below.</p>

                        <BuyButton href={GUMROAD_URL} target="_blank" rel="noopener noreferrer">Join the Membership</BuyButton>
                    </Body>
                </Wrapper>
            </DeskWrap>
            <Footer/>
        </>
    )
}

const DeskWrap = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;

    @media (min-width: 1000px) {
        flex-direction: row;
    }
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 90vh;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;

    @media (min-width: 1000px) {
        padding: 2rem;
    }
`

const Body = styled.div`
    font-family: var(--font-body);
    width: 95%;
    padding: 0 1rem;
    max-width: 100%;

    h1 {
        font-size: 1.8rem;
        margin-bottom: 1.5rem;
        color: #333;
    }

    h3 {
        font-size: 1.2rem;
        margin: 1.5rem 0 0.75rem;
        color: #333;
    }

    p {
        line-height: 1.7;
        margin-bottom: 1.1rem;
        color: #444;
    }

    a {
        color: #333;
        text-decoration: underline;
    }

    @media (min-width: 1000px) {
        max-width: 65ch;
        padding: 0 1rem;
    }
`

const Price = styled.p`
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    margin: 0 0 1.25rem;
`

const CoverImage = styled.img`
    width: 100%;
    max-width: 480px;
    display: block;
    margin: 0 0 1.75rem;
    transform: rotate(-1.5deg);
    box-shadow: 0 4px 14px rgba(0,0,0,0.15);
`

const BuyButton = styled.a`
    display: inline-block;
    margin-top: 1rem;
    padding: 0.85rem 1.75rem;
    background: #333;
    color: #f6f4ef!important;
    text-decoration: none;
    border-radius: 0.4rem;
    font-weight: 600;
    transition: background 0.2s ease;

    &:hover {
        background: #000;
    }
`

export default Membership;